import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconImages3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconImages3"><Path d="M14.25 6.75C13.0074 6.75 12 7.75736 12 9C12 10.2426 13.0074 11.25 14.25 11.25C15.4926 11.25 16.5 10.2426 16.5 9C16.5 7.75736 15.4926 6.75 14.25 6.75Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM19.5 18.4393L14 12.9393L12 14.9393L8.01583 10.9552L4.5 14.2642V4.5H19.5V18.4393Z" fill="currentColor"/></CentralIconBase>;
});

export default IconImages3;
